<!--
 * @Author: your name
 * @Date: 2021-06-28 13:26:06
 * @LastEditTime: 2024-03-13 17:01:37
 * @LastEditors: zhouhx
 * @Description: 抢单大厅
 * @FilePath: \gdp-cloud-app\src\views\mdt-consult\order-grabbing-hall\index.vue
-->
<template>
  <div class="consultListHall" ref="_wrap">
    <headers @getHeaderClickTime="getHeaderClickTime" :headerRightShow='false'></headers>
    <firstnav v-if='firstnavavShow' :navData="navData" :navstatus="navstatus" :indexs="indexs" @getClickFirstnav="getClickFirstnav" style="width: 100%; height: 44px"></firstnav>
    <div style="clear: both"></div>
    <div class="scrollList">
      <gdp-scroll v-if="data.length" ref="scroll" @pulling-down="onPullingDown" @pulling-up="onPullingUp">
        <van-swipe-cell class="cell" v-for="(item,key) in data" :key="key">
          <div class="cell">
            <div class="cellbody" @click="toDetail(item)">
              <div class="content">
                <div class="top">
                  <div class="topLeft">
                    {{ item.patientName }}
                  </div>
                  <div class="topRight hasdone">已申请</div>
                </div>
                <div class="center2">
                  <span class="centerLeft">{{ item.gmtModified }}</span>
                </div>
                <div class="center2">
                  <span class="centerLeft">{{ item.businessName }}</span>
                </div>
              </div>
            </div>
          </div>
          <template #right>
            <div @click="grabbingOrders(item, key)">
              <van-button square text="抢单" class="cellRightRead cellRight" />
            </div>
          </template>
        </van-swipe-cell>
      </gdp-scroll>
      <nodata v-else></nodata>
    </div>
    <dataModal ref='getHeightEdit' :dialogState="dataState" comfirmWidth="80%" comfirmHeight="300px" title='请选择会诊签收团队' @changeDataDialog="changeDataDialog" :btnArr="btnArr">
      <template v-slot:main>
        <el-radio v-model="radio" :label="item.id" v-for="(item,index) in teamData" :key='index' style="padding: 0 10px;">{{item.teamName}}</el-radio> <br />
      </template>
    </dataModal>
  </div>
</template>
<script>
import dataModal from '../../../components/basics/data-modal';
import headers from '../../../components/business/header.vue';
import firstnav from '../../../components/basics/first-nav.vue';
import nodata from '../../../components/basics/no-data.vue';
export default {
  props: {},
  data () {
    return {
      value1: 0,
      value2: null,
      option1: [
        { text: '时间倒序', value: 0 },
        { text: '时间正序', value: 1 }
      ],
      option2: [],
      searchListData: {
        current: 1,
        size: 6,
        userId: this.$store.state.userInfo.id,
        code: Number(this.$store.state.role.split('&')[0]),
        patientName: ''
      },
      caseListData: [],
      currentPage: 1,
      totalCount: 0,
      totalPage: 0,
      roleId: 0,
      navstatus: true,
      navData: [
        {
          text: '单人会诊',
          status: 0
        },
        {
          text: '多人会诊',
          status: 1
        }
      ],
      loading: false,
      finished: false,
      refreshing: false,
      data: [],
      indexs: 0,
      searchParame: {
        current: 1,
        size: 10,
        caseType: 1
      },
      firstnavavShow: false,
      signData: {},
      getTeamlistData: {},
      dataState: false,
      btnArr: [
        {
          name: '确定',
          backMsg: 'confirm',
          class: 'comfirmAndCancel smallComfirm'
        },
        {
          name: '取消',
          backMsg: 'cancel',
          class: 'comfirmAndCancel smallCancel'
        }
      ],
      radio: Number,
      teamData: []
    };
  },
  created () {
    this.getBusiness();
  },
  methods: {
    getList () {
      this.$axios
        .post('case/hall/list', {
          data: this.searchParame,
          version: 0
        })
        .then((res) => {
          this.data = res.data.list;
          this.pageCount = res.data.pageCount;
        });
    },
    getBusiness () {
      this.$axios
        .post('admin/business/user/business/get', {
          data: {
            id: this.$store.state.userInfo.id
          },
          version: $version
        })
        .then((res) => {
          if (res.status) {
            if (res.data.single !== null && res.data.many !== null) {
              this.firstnavavShow = true;
            } else {
              this.firstnavavShow = false;
            }
            this.getList();
          }
        });
    },
    reset () {
      this.searchParame.current = 1;
      this.data = [];
      this.getBusiness();
    },
    getHeaderClickTime (time, keyWord) {
      this.data = [];
      // 重置页码
      this.searchParame.current = 1;
      this.searchParame.startTime = time[0];
      this.searchParame.endTime = time[1];
      if (time[0] && time[1]) {
        this.searchParame.startTime = time[0] + ' 00:00:00';
        this.searchParame.endTime = time[1] + ' 00:00:00';
      } else {
        this.searchParame.startTime = '';
        this.searchParame.endTime = '';
      }
      this.searchParame.patientName = keyWord;
      this.getBusiness();
    },
    // 下拉刷新
    onPullingDown () {
      this.reset();
    },
    // 上拉加载
    onPullingUp () {
      if (this.searchParame.current < this.pageCount) {
        this.searchParame.current++;
        this.getBusiness();
      } else {
        this.$refs.scroll.forceUpdate();
      }
    },
    onClickLeft () {
      this.$toast('返回');
    },
    onClickRight () {
      this.$toast('按钮');
    },
    getClickFirstnav (e) {
      if (e === 0) {
        this.searchParame.caseType = 1;
      } else {
        this.searchParame.caseType = 2;
      }
      this.indexs = Number(e);
      this.data = [];
      this.getList();
    },
    grabbingOrders (data, index) {
      this.signData.caseId = data.id;
      if (data.consultType === '1') {
        this.grabOrder();
      } else {
        this.getTeamlistData.businessId = data.businessId;
        this.getTeamlistData.userId = this.$store.state.userInfo.id;
        this.dataState = true;
        // 打开时获取弹框内容的高度
        this.$nextTick(() => {
          this.getTeamList();
          this.$refs.getHeightEdit.handleOpen();
        });
      }
    },
    // 获取多人会诊团队
    getTeamList () {
      this.$axios
        .post('admin/team/list/byLeader', {
          data: this.getTeamlistData,
          version: this.$version
        })
        .then((res) => {
          if (res.status) {
            this.teamData = res.data;
            this.radio = res.data[0].id;
          }
        });
    },
    // 抢单事件
    grabOrder () {
      this.$axios
        .post('case/hall/sign', {
          data: this.signData,
          version: this.$version
        })
        .then((res) => {
          if (res.status) {
            this.getList();
          }
        });
    },
    // 弹框事件
    changeDataDialog (e) {
      if (e === 'confirm') {
        this.signData.teamId = this.radio;
        this.grabOrder();
      }
      this.dataState = false;
    },
    toDetail (content) {
      this.$router.push({
        path: '/casedetail',
        query: {
          caseid: content.id,
          caseMethod: content.caseMethod,
          consultType: 'lobby'
        }
      });
    }
  },
  watch: {},
  computed: {},
  components: {
    headers,
    firstnav,
    dataModal,
    nodata
  }
};
</script>
<style lang="scss" scoped>
.readed {
  background-color: $grey !important;
}
.header {
  background: red !important;
}
.consultListHall {
  background: $slightgreyf8;
  overflow: hidden;
  position: relative;
  z-index: 1;
  min-height: calc(100vh - 0px);
  overflow: hidden;
  .scrollList {
    height: calc(100% - 50px);
    overflow: hidden;
    margin-top: 52px;
  }
  .cell {
    height: $listHeight;
    margin-top: 6px;
    background-color: $white;
    .cellbody {
      padding: 15px 16px;
      .content {
        .top {
          display: flex;
          -webkit-box-pack: justify;
          justify-content: space-between;
          margin-bottom: 6px;
          .topLeft {
            font-weight: 700;
            font-family: PingFangSC-Semibold;
            font-size: 16px;
            color: $black;
            letter-spacing: 0.13px;
          }
          .topRight {
            width: 52px;
            height: 24px;
            line-height: 24px;
            font-family: PingFangSC-Medium;
            font-size: 10px;
            text-align: center;
          }
          .nodone {
            background: $slightgrey;
            color: $grey;
          }
          .needdone {
            background: $sligtblue;
            color: $blue;
          }
          .hasdone {
            background: $sligtgreen;
            color: $green;
          }
        }
        .center2 {
          margin: 8px 0;
          .centerLeft {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: $black;
            letter-spacing: 0.1px;
            text-align: justify;
          }
        }
        .bottom {
          .bottomLeft {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: $black;
            letter-spacing: 0;
            float: left;
          }
          .bottomRight {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: $grey;
            letter-spacing: 0.15px;
            text-align: right;
            float: right;
          }
        }
      }
    }
    /* .read{
        padding: 0 10px;
      } */
    .cellRight {
      /* position: absolute;
        top:50%;
        right: 0;
        transform: translateY(-50%); */
      width: 50px;
      height: 50px;
      border-radius: 50%;
      padding: 0;
      font-size: 14px;
      text-align: center;
      letter-spacing: 0.13px;
      color: $white;
    }
    .cellRightRead {
      background: $blue;
      padding: 3px;
    }
    .cellRightDelete {
      background: $red;
    }
  }
}
</style>
